module.exports = __webpack_public_path__ + "static/media/dH20-open.5a3cb220.svg";